<script>
// 线性 SVG 图标库（克制、专业，1.6px 描边，圆角端点）
// 参考现代企业级图标质感（Lucide / SF Symbols 风格）

// 每个图标基于 24x24 viewBox，统一 1.6 stroke，round caps/joins
const icons = {
  // 上货/条码
  tag: `<path d="M3.5 3.5h6l10.9 10.9a1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4 0L3.5 10.4v-6.9z"/><circle cx="8" cy="8" r="1.4"/>`,
  // 扫码/开单
  scan: `<path d="M4 8V5a1 1 0 0 1 1-1h3"/><path d="M16 4h3a1 1 0 0 1 1 1v3"/><path d="M20 16v3a1 1 0 0 1-1 1h-3"/><path d="M8 20H5a1 1 0 0 1-1-1v-3"/><line x1="4" y1="12" x2="20" y2="12"/>`,
  // 库存/盒子
  box: `<path d="M4 7.5 12 3.5l8 4v9l-8 4-8-4v-9z"/><path d="M4 7.5l8 4 8-4M12 11.5v9"/>`,
  // 报表/图表
  chart: `<path d="M4 20V10"/><path d="M9.5 20V5"/><path d="M15 20v-8"/><path d="M20 20V9"/><path d="M2.5 20h19"/>`,
  // 会员/用户
  user: `<path d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"/><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/>`,
  // 员工/团队
  team: `<path d="M9 12a3.6 3.6 0 1 0 0-7.2A3.6 3.6 0 0 0 9 12z"/><path d="M2.5 20.5a6.5 6.5 0 0 1 13 0"/><path d="M16.5 5.5a3.2 3.2 0 0 1 0 6.3"/><path d="M17.5 14.5a6 6 0 0 1 4 6"/>`,
  // 多店/门店
  store: `<path d="M4 4.5h16l1 4a2.5 2.5 0 0 1-2.5 2.5 2.6 2.6 0 0 1-2.5-2.5A2.6 2.6 0 0 1 13.5 11 2.6 2.6 0 0 1 11 8.5a2.6 2.6 0 0 1-2.5 2.5A2.6 2.6 0 0 1 6 8.5 2.5 2.5 0 0 1 3.5 6.5l.5-2z"/><path d="M5 11.5V20h14v-8.5"/><path d="M9.5 20v-4h5v4"/>`,
  // 组织/权限
  org: `<rect x="9" y="3" width="6" height="6" rx="1"/><path d="M5.5 8.5v4a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-4"/><line x1="12" y1="14.5" x2="12" y2="20"/>`,
  // 同步/跨店
  sync: `<path d="M20 12a8 8 0 0 1-13.7 5.6L4 15.5"/><path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.5"/><path d="M4 15.5V11.5M20 8.5V12.5"/>`,
  // 集成/链接
  link: `<path d="M10 13.5a4 4 0 0 0 5.7 0l2.7-2.7a4 4 0 1 0-5.7-5.7l-1.2 1.2"/><path d="M14 10.5a4 4 0 0 0-5.7 0l-2.7 2.7a4 4 0 1 0 5.7 5.7l1.2-1.2"/>`,
  // 服务/支持（耳机）
  service: `<path d="M4 13a8 8 0 0 1 16 0"/><rect x="3" y="12.5" width="4" height="6" rx="1.6"/><rect x="17" y="12.5" width="4" height="6" rx="1.6"/><path d="M20 18.5a3 3 0 0 1-3 3h-2"/>`,
  // 电话
  phone: `<path d="M5.5 3.5h2.8c.4 0 .8.3.9.7l.6 2.8c.1.4-.1.8-.4 1l-1.2 1a12 12 0 0 0 5.4 5.4l1-1.2c.2-.3.6-.5 1-.4l2.8.6c.4.1.7.5.7.9v2.8a1.5 1.5 0 0 1-1.5 1.5C9.2 19.4 4.6 14.8 4.5 5.5A1.5 1.5 0 0 1 5.5 3.5z"/>`,
  // 对勾
  check: `<path d="M20 6.5 9 17.5 4 12.5"/>`,
  // 箭头
  arrow: `<path d="M4.5 12h15"/><path d="M13.5 6l6 6-6 6"/>`,
  // 关闭
  close: `<path d="M6 6l12 12M18 6L6 18"/>`,
  // 菜单
  menu: `<path d="M4 7h16M4 12h16M4 17h16"/>`,
  // 星星
  star: `<path d="M12 3.5l2.5 5.2 5.6.7-4.1 4 1 5.6-5-2.7-5 2.7 1-5.6-4.1-4 5.6-.7L12 3.5z"/>`,
  // 盾牌
  shield: `<path d="M12 3l7 2.5v5.2a8.5 8.5 0 0 1-7 8.3 8.5 8.5 0 0 1-7-8.3V5.5L12 3z"/><path d="M9 11.5l2 2 4-4"/>`,
  // 浏览器/多端
  monitor: `<rect x="3" y="4.5" width="18" height="12" rx="2"/><path d="M9 20.5h6M12 16.5v4"/>`,
  // 移动端
  mobile: `<rect x="7" y="3" width="10" height="18" rx="2"/><line x1="10.5" y1="18" x2="13.5" y2="18"/>`,
  // 渐变/升级（Nova）
  rocket: `<path d="M12 3c2.5 2 3.5 5 3.5 8.5 0 2-.4 3.8-1.2 5.2H9.7C8.9 15.3 8.5 13.5 8.5 11.5 8.5 8 9.5 5 12 3z"/><path d="M8.5 16.5 6 19.5M15.5 16.5 18 19.5M12 14v5"/>`,
  // 箭头小
  chevron: `<path d="M9 6l6 6-6 6"/>`,
}

export default {
  name: 'AppIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: 24 },
  },
  computed: {
    iconPath() {
      return icons[this.name] || ''
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    class="app-icon"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-html="iconPath"
  />
</template>

<style scoped>
.app-icon {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/site/components/common/AppIcon.vue